"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tversionRequest = void 0;
const tversionRequest = (url, options) => {
    const { headers, tversion } = options;
    if (typeof tversion !== 'undefined' && Number(tversion) !== 0) {
        return {
            url,
            options: Object.assign(Object.assign({}, options), { headers: Object.assign(Object.assign({}, headers), { tversion }) }),
        };
    }
    return { url, options };
};
exports.tversionRequest = tversionRequest;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHZlcnNpb24tcmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvcmVxdWVzdC9pbnRlcmNlcHRvcnMvdHZlcnNpb24tcmVxdWVzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFNQSxNQUFNLGVBQWUsR0FBRyxDQUFDLEdBQVcsRUFBRSxPQUErQixFQUFFLEVBQUU7SUFDdkUsTUFBTSxFQUFFLE9BQU8sRUFBRSxRQUFRLEVBQUUsR0FBRyxPQUFPLENBQUM7SUFDdEMsSUFBSSxPQUFPLFFBQVEsS0FBSyxXQUFXLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUM3RCxPQUFPO1lBQ0wsR0FBRztZQUNILE9BQU8sa0NBQ0YsT0FBTyxLQUNWLE9BQU8sa0NBQ0YsT0FBTyxLQUNWLFFBQVEsTUFFWDtTQUNGLENBQUM7S0FDSDtJQUNELE9BQU8sRUFBRSxHQUFHLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDMUIsQ0FBQyxDQUFDO0FBQ08sMENBQWUifQ==